import { ProductInventoryDto } from "@insite/client-framework/Types/ApiModels";

const getAvailability = (inventory: ProductInventoryDto | undefined, unitOfMeasure: string) => {
    return inventory?.inventoryAvailabilityDtos?.find(
        o => o.unitOfMeasure.toLowerCase() === (unitOfMeasure?.toLowerCase() || ""),
    )?.availability;
};

export default getAvailability;
